import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorBillSearch = () => {
  const billSearch = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/fund-bill/search', payload, (response) => {
      loading(false)
      if (response.status_code === 200) {
        if (response.data) {
          callback(response.data)
        }
      }
    })
  }, [])
  return { billSearch }
}

export default InteractorBillSearch
